import type { SystemMessage } from '@/types'
import { get } from '@/util/auth'

import { API_ROUTE_SYSTEM_MESSAGES } from './api-routes'

export const commonSystemMessagesResources = {
  getList: (): Promise<SystemMessage[]> => get(API_ROUTE_SYSTEM_MESSAGES),
}
